export const validPhases = [
    'search',
    'examination',
    'opposition',
    'appeal',
    'post grand',
    'intake',
    'receiving section office',
];

export const validProcedureTypes = [
    'PCT',
    'EP',
    'NS_BO',
    'NS_FA',
    'NS_FS',
    'NS_GO',
    'NS_RO',
    'NS_CO',
    'NS_IO',
    'NS_MO',
    'NS_SN',
    'NS_LT',
    'NS_NO',
    'NS_TO',
];

export const procedureTypes: { [key: string]: { label: string; code: string } } = {
    PCT: { label: 'PCT', code: 'PCT' },
    EP: { label: 'EP', code: 'EP' },
    NS_BO: { label: 'BO', code: 'BO' },
    NS_FA: { label: 'FA', code: 'FA' },
    NS_FS: { label: 'FS', code: 'FS' },
    NS_GO: { label: 'GO', code: 'GO' },
    NS_RO: { label: 'RO', code: 'RO' },
    NS_CO: { label: 'CO', code: 'CO' },
    NS_IO: { label: 'IO', code: 'IO' },
    NS_MO: { label: 'MO', code: 'MO' },
    NS_SN: { label: 'SN', code: 'SN' },
    NS_LT: { label: 'LT', code: 'LT' },
    NS_NO: { label: 'NO', code: 'NO' },
    NS_TO: { label: 'TO', code: 'TO' },
    NS_DEFAULT: { label: 'BO', code: 'DEFAULT' },
};

export const isPhaseValid = (phase: string) => validPhases.includes(phase);
export const phaseChar = (phase: string) => isPhaseValid(phase) ? phase[0].toUpperCase() : 'D'
